/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CreateAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/AutomationsTable/Automation/CreateAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let appConnectionsValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'connections',
})
let automationIdValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'id',
})
let automationIsCreatedValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'is_created',
})
let aggregateData = fromHelpers.getView(appConnectionsValueData, automationIdValueData, automationIsCreatedValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}